import { Controller } from "@hotwired/stimulus"

let debounce = undefined;

export default class extends Controller {
  static targets = [ 'input', 'hiddenInput', 'errorMessage', 'resultsContainer']
  static values = {
    parserId: Number
  }

  ids = [];

  connect() {
    // console.log("Hello, TFRRS Help Controller from Stimulus!", this.element)
    // console.log(this.inputTarget);
    // console.log(this.containerTarget)
    // console.log(this.addButtonTarget)
  }

  checkTfrrsUrl() {
    const url = this.inputTarget.value;
    if (url.includes('tfrrs.org')) {

      if (url.includes('xc')) {
        this.errorMessageTarget.innerHTML = '<p class="font-fanword-bold color-fanword-green">Cross Country teams do not need IDs. You are good to go!</p>';
        return;
      }

      this.findTfrrsIds();
    } else {
      this.errorMessageTarget.innerHTML = '<p class="font-fanword-bold color-fanword-red">The URL entered is not a valid TFRRS track & field event page. Please try again.</p>';
    }

    if (url === '') {
      this.errorMessageTarget.innerHTML = '';
    }
  }

  findTfrrsIds() {
    if (debounce) {
      clearTimeout(debounce);
    }

    debounce = setTimeout(() => {
      const url = this.inputTarget.value;

      this.errorMessageTarget.innerHTML = '';
      this.resultsContainerTarget.innerHTML = '<p><i class="fas fa-spinner fa-spin"></i> Looking up IDs from this event...</p>';

      let idMap = {};

      fetch(url).then(res => res.text()).then(pageContent => {
        // console.log(pageContent);
        const doc = new DOMParser().parseFromString(pageContent, 'text/html');
        const teamFilterOptions = doc.querySelectorAll('.form-control[name="team_filter"] option');
        // console.log(teamFilterOptions);

        teamFilterOptions.forEach(option => {
          if (option.value.includes('Filter')) {
            return;
          }

          idMap[option.value] = option.textContent;
        });

        this.displayIds(idMap);
      });

      // fetch(`/tfrrs_ids?url=${url}`).then(res => res.text()).then(partial => {
      //   this.idsContainerTarget.innerHTML = '';
      //   this.idsContainerTarget.insertAdjacentHTML('beforeend', partial);
      // });
    }, 1000);

  }

  displayIds(idMap) {
    // console.log('ID Map', idMap);

    fetch(`/tfrrs_ids`, {
      method: 'POST',
      body: JSON.stringify({ idMap: idMap })
    }).then(res => res.text()).then(partial => {
      this.resultsContainerTarget.innerHTML = '';
      this.resultsContainerTarget.insertAdjacentHTML('beforeend', partial);

      const submitButton = document.querySelector(`#submit-id-helper-${this.parserIdValue}-modal`);
      if (submitButton) {
        submitButton.disabled = false;
      }
    });

  }

}

